import {FC,} from "react";
import {Route} from "react-router-dom";
import {Navigate, Routes} from "react-router";
import {LoanManagerLegacyTradeListPage} from "./List";


export const LoanManagerLegacyTradePage: FC = () => {
  return (
      <Routes>
        <Route index element={<LoanManagerLegacyTradeListPage/>}/>
        <Route path="*" element={<Navigate to="/" replace/>}/>
      </Routes>
  );
}


